import {
  React,
  Component,
  withCookies,
  axios,
  routes
} from 'imports/CommonImports';

import {
  CircularProgress,
  Divider,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
  SelectField,
  MenuItem,
  TextField,
} from 'material-ui';

const styles = {
  matrixContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0em 1em',
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '1em 0em',
    minHeight: '3em',
  },
  nameContainer: {
    flex: 1,
  },
  optionContainer:{
    flex: 4,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontStyle: 'italic',
    marginLeft: '2em',
  },
  selectFieldContainer:{
    flex: 4,
    alignItems: 'center',
    display: 'flex',
    marginLeft: '2em'
  },
  selectField: {
    width: '25%',
    fontStyle: 'italic'
  },
  option: {
    display: 'table-cell',
    flex: 1,
    width: '25%',
  },
  fakeOption: {
    display: 'table-cell',
    visibility: 'hidden',
    flex: 1,
    width: '25%'
  },
  otherTextfield: {
    marginLeft: '0.6em'
  },
  saveButton: {
    border: '1px solid #88d5c6',
    color: '#88d5c6',
    marginTop: '3em',
    width: '10em'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '2em 0'
  },
  divider: {
    margin: '0'
  }
}

class FilterMatrix extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      filters: {},
      loadingDialogOpen: false,
      textInput: '',
      choices: props.choices,
    }
  }

  componentWillMount(){
    if(this.props.data !== null){
      this.setState({
        filters: this.props.data,
        loading: false,
        error: false,
      });
    }
    else {
      this.getFilters()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.choices !== prevState.choices || this.state.textInput !== prevState.textInput) {
      this.props.update(this.state.choices, this.state.textInput);
    }
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los filtros. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.matrixContainer}>
        {
          this.state.filters.map((filter, i) => {
            return([
              this.manageFilter(filter, i),
              <Divider style={styles.divider} key={'1.' + i}/>]
            );
          })
        }
      </div>
    );
  }

  checkboxChange = (filter, option) => {
    var index = this.state.choices[filter.id].indexOf(option.name);
    if(index === -1){
      this.setState({choices: {...this.state.choices, [filter.id]: [...this.state.choices[filter.id], option.name]}})
    }
    else {
      this.setState((prevState) => ({
        choices: {...this.state.choices, [filter.id]: prevState.choices[filter.id].filter((_,i) => i !== index)}
      }));
    }
  }

  manageFilter = (filter, i) => {
    // Multiple choices
    if(filter.type === "MC"){
      return (
        <div style={styles.filterContainer} key={i}>
          <div style={styles.nameContainer}><b style={styles.name}>{filter.name}</b></div>
          <div style={styles.optionContainer}>

            {Array.from(new Array(4), (x, j) => {
              if(filter.options.length > j){
                return(
                  <Checkbox
                  disabled={this.props.done}
                  style={styles.option}
                  key={j}
                  label={filter.options[j].name}
                  className='p2'
                  onCheck={() => this.checkboxChange(filter, filter.options[j])}
                  defaultChecked={this.props.choices[filter.id] ? this.props.choices[filter.id].includes(filter.options[j].name) : false}
                  />
                );
              }
              return (
                <Checkbox
                style={styles.fakeOption}
                key={j}
                label="Fake checkbox"
                />
              )
              })
            }
          </div>
        </div>
      );
    }
    // Single choice
    else if(filter.type === "SC"){
      return (
        <div style={styles.filterContainer} key={i}>
          <div style={styles.nameContainer}><b style={styles.name}>{filter.name}</b></div>
          <RadioButtonGroup name={filter.name} style={styles.optionContainer} defaultSelected={this.state.choices[filter.id]} onChange={(event, value) => {this.setState({choices: {...this.state.choices, [filter.id]: value}})}}>
            {filter.options.map((option, j) => {
                return(
                  <RadioButton
                  disabled={this.props.done}
                  style={styles.option}
                  key={j}
                  label={option.name}
                  className='p2'
                  value={option.name}
                  />
                );

              })
            }
            </RadioButtonGroup>
        </div>
      );
    }
    // Dropdown with other
    else if(filter.type === "DO"){
      return (
        <div style={styles.filterContainer} key={i}>
          <div style={styles.nameContainer}><b style={styles.name}>{filter.name}</b></div>
          <div style={styles.selectFieldContainer}>
          <SelectField disabled={this.props.done} style={styles.selectField} hintText='Selecciona una opción' value={this.state.choices[filter.id]} onChange={(event, index, value) => {this.setState({choices: {...this.state.choices, [filter.id]: value}, textInput: ''})}}>
            <MenuItem
            primaryText=''
            value={null}
            />
            {filter.options.map((option, j) => {
                return(
                  <MenuItem
                  key={j}
                  primaryText={option.name}
                  value={option.name}
                  />
                );
              })
            }
            <MenuItem
            primaryText='Otro'
            value='other'
            />
            </SelectField>
            {this.state.choices[filter.id] === 'other' ?
            <TextField
              style={styles.otherTextfield}
              value={this.state.textInput}
              hintText="Otro indicador"
              onChange={(event) => {this.setState({textInput: event.target.value})}}
            /> :
            null }
            </div>
        </div>
      );
    }
    // Dropdown without other
    else if(filter.type === "DN"){
      return (
        <div style={styles.filterContainer} key={i}>
          <div style={styles.nameContainer}><b style={styles.name}>{filter.name}</b></div>
          <div style={styles.selectFieldContainer}>
          <SelectField disabled={this.props.done} style={styles.selectField} hintText='Selecciona una opción' value={this.state.choices[filter.id]} onChange={(event, index, value) => {this.setState({choices: {...this.state.choices, [filter.id]: value}})}}>
            <MenuItem
            primaryText=''
            value={null}
            />
            {filter.options.map((option, j) => {
                return(
                  <MenuItem
                  key={j}
                  primaryText={option.name}
                  value={option.name}
                  />
                );

              })
            }
            </SelectField>
            </div>
        </div>
      );
    }
  }

  getFilters = () => {
    let token = this.props.cookies.get('token');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.getFilters)
      .then((response) => {
        this.props.addMatrixData(response.data);
        this.setState({
          filters: response.data,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          loading: false
        })
      });
  }
}

export default withCookies(FilterMatrix);



// WEBPACK FOOTER //
// ./src/components/conventions/FilterMatrix.js